<template lang="pug">
  #moloko
    navbar(v-if="$route.meta.requiresAuth")
    router-view
</template>

<style src="./sass/molokoden.sass" lang="sass"></style>

<script>
import Navbar from './views/Navbar.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'molokoden',
    components: {
        Navbar
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['isOnline', 'isLogged', 'isMobile']),
    },
    created() {
        this.$store.commit('setMd')
        this.$store.commit('setOnline', navigator.onLine)
        window.addEventListener('offline', () => {
            this.$store.commit('setOnline', false)
        })
        window.addEventListener('online', () => {
            this.$store.commit('setOnline', true)
        })
        this.$i18n.locale = window.navigator.language ? window.navigator.language.substring(0,2) : 'ru'
    },
    mounted() {
        if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
            navigator.serviceWorker
                .register('/service-worker.js')
                .then(registration => {
                    console.log('ServiceWorker registration successful!')
                })
                .catch(err => {
                    console.log('ServiceWorker registration failed: ', err)
                })
        }
        if (this.isMobile) {
            let v = document.getElementById('moloko')
            v.classList.add('is-mobile')
        }
    },
    updated() {
        this.$store.commit('setMd')
        this.$store.commit('setOnline', navigator.onLine)
    }
}
</script>
